import { translate } from "app/language/service"
import { ICsvFileColumn } from "app/model"
import { downloadCsvFile, generateCsvFileContent } from "app/tools/file"
import { formatDate } from "app/util/date/tools/common"
import { messageSVC } from "message/service"
import { IReportResult, REPORTS_HIDDEN_COLUMN_KEYS } from "reports/model"

export const downloadReportResultCsvFile = (results: IReportResult[]): void => {
  try {
    const columns: ICsvFileColumn[] = Object.keys(results[0])
      .filter(key => !REPORTS_HIDDEN_COLUMN_KEYS.includes(key))
      .map(key => ({
        key,
        label: translate(`reports.column.${key}`)
      }))
    const fileContent: string = generateCsvFileContent(columns, results)
    const fileName: string = `reports-data-${formatDate(new Date())}`
    downloadCsvFile(fileName, fileContent)
  } catch (error) {
    console.error(error)
    messageSVC.error(translate("reports.export.error"))
  }
}
